import { Form, FormGroup, Text } from '../form';

export default ({ file, id, messages, onChange }) => (
  <div className="title">
    <Form initialValues={{title: file.name}}>
      {({ formState }) => (
        <FormGroup label={messages.uploaderLinkText}>
          <Text
            field="title"
            id={`${id}-title`}
            onChange={onChange}
            placeholder={file.name}
          />
        </FormGroup>
      )}
    </Form>

    <style jsx>{`
      .title {
        margin-top: 10px;
      }
    `}</style>
  </div>
);
